import moduleLoginStatus from './modules/moduleLoginStatus/moduleLoginStatus'
import windowConfig from './modules/moduleWindowConfig'


export default new Vuex.Store({
    modules:{
        loginStatus:moduleLoginStatus,
        windowConfig,
    }
})
